<template>
  <shared-product-edit :product="product" :images="images"/>
</template>

<script>
  import SharedProductEdit from '@/components/marketplace/shared/ProductEdit'

  export default {
    props: {
      product: {
        type: Object,
        required: true
      }
    },
    methods: {
      formatProduct () {
        return {}
      }
    },
    computed: {
      images () {
        return this.product.images
      }
    },
    components: {
      SharedProductEdit
    }
  }
</script>

<style lang="sass" scoped>
  .margin
    margin-top: 10px
</style>



// WEBPACK FOOTER //
// ProductEdit.vue?e58eb8b6